"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  const COLS = 56;
  const ROWS = 32;
  const TOTAL = COLS * ROWS;
  const [gridVisible, setGridVisible] = useState(false);
  const [activeDot, setActiveDot] = useState<number | null>(null);
  useEffect(() => {
    const t = setTimeout(() => setGridVisible(true), 50);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      const next = Math.floor(Math.random() * TOTAL);
      setActiveDot(next);
      const clear = setTimeout(() => setActiveDot(null), 1200);
      return () => clearTimeout(clear);
    }, 4000);
    return () => clearInterval(interval);
  }, [TOTAL]);
  const dots = Array.from({
    length: TOTAL
  });
  return <section data-section-id="6605" id="applaunchhero" className="relative overflow-hidden bg-background text-foreground py-32 md:py-44">
      {}
      <div className="pointer-events-none absolute inset-0 transition-opacity duration-700 ease-out" style={{
      opacity: gridVisible ? 0.3 : 0
    }} aria-hidden="true">
        <div className="absolute inset-0 grid" style={{
        gridTemplateColumns: `repeat(${COLS}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${ROWS}, minmax(0, 1fr))`
      }}>
          {dots.map((_, i) => {
          const isActive = activeDot === i;
          return <div key={i} data-index={i} className="flex items-center justify-center">
                <span className="block size-[2px] rounded-lg transition-all duration-[1200ms] ease-out" style={{
              backgroundColor: isActive ? "var(--primary)" : "var(--border)",
              boxShadow: isActive ? "0 0 8px 1px var(--primary)" : "none"
            }} />
              </div>;
        })}
        </div>
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, transparent 0%, transparent 40%, var(--background) 95%)"
      }} />
      </div>

      {}
      <div className="relative mx-auto max-w-[1280px] px-6 md:px-8">
        <div className="mx-auto flex max-w-[880px] flex-col items-center text-center">
          {}
          <div className="mb-10 font-mono text-xs uppercase text-muted-foreground" style={{
          letterSpacing: "0.08em"
        }}>
            
          </div>

          {}
          <h1 className="font-default font-semibold text-foreground" style={{
          fontSize: "clamp(2.5rem, 5.4vw, 4.75rem)",
          letterSpacing: "-0.025em",
          lineHeight: "1.02"
        }}>Μεγάλα Νέα! Η Εφαρμογή HotelDeals είναι ΕΔΩ! </h1>

          {}
          <p className="mt-6 max-w-[640px] font-default text-muted-foreground" style={{
          fontSize: "clamp(1.0625rem, 1.25vw, 1.1875rem)",
          lineHeight: "1.55",
          letterSpacing: "-0.005em"
        }}>Κατέβασέ το στο Google Play</p>

          {}
          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:gap-5">
            <Link to="https://play.google.com/store/apps/details?id=hoteldealsgr.aplixcw&pcampaignid=web_share" newTab className="w-full sm:w-auto">
              <Button className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs py-2 has-[>svg]:px-3 h-11 w-full rounded-lg bg-primary px-6 font-semibold text-primary-foreground !text-4xl disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 sm:w-auto" style={{
              letterSpacing: "-0.005em"
            }}>Κατέβασε το</Button>
            </Link>

            <Link to="/HowItWorksPage" className="group inline-flex items-center gap-1.5 font-default text-sm font-medium text-primary">
              
              
            </Link>
          </div>
        </div>
      </div>
    </section>;
}